import { createRouter, createWebHistory } from 'vue-router';

// 导入组件
import SubmitForm from '../components/SubmitForm.vue';

// 定义路由
const routes = [
  {
    path: '/',
    redirect: '/index',
    children: [
      { path: 'index', component: SubmitForm },
    ]
    
  },
  {
    path: '/index',
    component: SubmitForm
  },
  
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;